/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Segment, Accordion } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { defineMessages, useIntl } from 'react-intl';
import {
  ObjectBrowserWidget,
  CheckboxWidget,
  TextWidget,
  AlignWidget,
  ColorPickerWidget,
  SelectWidget,
} from '@plone/volto/components';
import { LinkToWidget, SizeWidget } from '@redturtle/iovisit-theme/components';
import config from '@plone/volto/registry';

const messages = defineMessages({
  ctaImage: {
    id: 'ctaImage',
    defaultMessage: "Seleziona l'immagine da mostrare",
  },
  ctaImageEnable: {
    id: 'ctaImageEnable',
    defaultMessage: "Mostra l'immagine",
  },
  ctaBgColor: {
    id: 'ctaBgColor',
    defaultMessage: 'Colore di sfondo',
  },
  ctaColor: {
    id: 'ctaColor',
    defaultMessage: 'Colore della CTA',
  },
  ctaFullWidth: {
    id: 'ctaFullWidth',
    defaultMessage: 'Mostra a pieno schermo',
  },
  ctaTextAlignment: {
    id: 'ctaTextAlignment',
    defaultMessage: 'Allineamento testo',
  },
  ctaLinkTitle: {
    id: 'ctaLinkTitle',
    defaultMessage: 'Titolo per il link della CTA',
  },
  ctaLink: {
    id: 'ctaLink',
    defaultMessage: 'Link della CTA',
  },
  primary: {
    id: 'primary',
    defaultMessage: 'Primario',
  },
  secondary: {
    id: 'secondary',
    defaultMessage: 'Secondario',
  },
  tertiary: {
    id: 'tertiary',
    defaultMessage: 'Terziario',
  },
  white: {
    id: 'white',
    defaultMessage: 'Bianco',
  },
  transparent: {
    id: 'transparent',
    defaultMessage: 'Trasparente',
  },
  size: {
    id: 'Size',
    defaultMessage: 'Dimensione',
  },
});

const DEFAULT_HEADLINE_LEVELS = [
  ['h2', 'h2'],
  ['h3', 'h3'],
];

const Sidebar = ({ data, block, onChangeBlock, openObjectBrowser }) => {
  const intl = useIntl();

  useEffect(() => {
    if (data.showFullWidth === undefined) {
      onChangeBlock(block, {
        ...data,
        showFullWidth: true,
      });
    }
  }, []);

  if (data.showImage === null || data.showImage === undefined) {
    data.showImage = false;
  }
  const allowed_headline_tags =
    config.blocks?.blocksConfig?.listing?.allowed_headline_tags ||
    DEFAULT_HEADLINE_LEVELS;
  return (
    <Segment.Group raised key={block.id || block}>
      <header className="header pulled">
        <h2>
          <FormattedMessage id="cta_block" defaultMessage="Blocco CTA" />
        </h2>
      </header>
      <Accordion className="form">
        <Accordion.Content active={true}>
          <ObjectBrowserWidget
            id="ctaImage"
            title={intl.formatMessage(messages.ctaImage)}
            value={data.ctaImage || []}
            mode="image"
            widgetOptions={{
              pattern_options: { selectableTypes: ['Image'] },
            }}
            onChange={(name, value) => {
              onChangeBlock(block, {
                ...data,
                [name]: value || [],
                showImage: !!value,
              });
            }}
          />
          <CheckboxWidget
            id="showImage"
            title={intl.formatMessage(messages.ctaImageEnable)}
            value={data.ctaImage?.length > 0 && data.showImage}
            onChange={(name, checked) => {
              onChangeBlock(block, { ...data, [name]: checked });
            }}
            isDisabled={!data.ctaImage?.length > 0}
          />

          {(!data.ctaImage || data.ctaImage.length === 0) && (
            <ColorPickerWidget
              id="bgColor"
              title={intl.formatMessage(messages.ctaBgColor)}
              colors={[
                {
                  name: 'primary',
                  label: intl.formatMessage(messages.primary),
                },
                {
                  name: 'secondary',
                  label: intl.formatMessage(messages.secondary),
                },
                {
                  name: 'tertiary',
                  label: intl.formatMessage(messages.tertiary),
                },
                {
                  name: 'white',
                  label: intl.formatMessage({
                    id: 'white',
                    defaultMessage: 'Bianco',
                  }),
                },
              ]}
              onChange={(name, value) => {
                onChangeBlock(block, { ...data, [name]: value });
              }}
            />
          )}

          <CheckboxWidget
            id="showFullWidth"
            title={intl.formatMessage(messages.ctaFullWidth)}
            value={data.showFullWidth ? data.showFullWidth : false}
            onChange={(name, checked) => {
              onChangeBlock(block, { ...data, [name]: checked });
            }}
          />
          <SelectWidget
            id="headlineTag"
            title={intl.formatMessage({
              id: 'Headline level',
            })}
            value={data.headlineTag || 'h2'}
            onChange={(name, value) => {
              onChangeBlock(block, { ...data, [name]: value });
            }}
            choices={allowed_headline_tags}
            isMulti={false}
            noValueOption={false}
          />
          <AlignWidget
            id="textAlignment"
            title={intl.formatMessage(messages.ctaTextAlignment)}
            actions={['left', 'center']}
            onChange={(name, value) => {
              onChangeBlock(block, { ...data, [name]: value });
            }}
            value={data.textAlignment}
          />

          <TextWidget
            id="ctaLinkTitle"
            title={intl.formatMessage(messages.ctaLinkTitle)}
            value={data.ctaLinkTitle}
            onChange={(name, value) => {
              onChangeBlock(block, {
                ...data,
                [name]: value,
              });
            }}
          />
          <LinkToWidget
            data={data}
            openObjectBrowser={openObjectBrowser}
            linkField="ctaLink"
            title={intl.formatMessage(messages.ctaLink)}
            showTarget={true}
            onChange={(name, value) =>
              onChangeBlock(block, {
                ...data,
                [name]: value,
              })
            }
          />

          <ColorPickerWidget
            id="ctaColor"
            title={intl.formatMessage(messages.ctaColor)}
            colors={[
              { name: 'primary', label: intl.formatMessage(messages.primary) },
              {
                name: 'secondary',
                label: intl.formatMessage(messages.secondary),
              },
              {
                name: 'tertiary',
                label: intl.formatMessage(messages.tertiary),
              },
              { name: 'white', label: intl.formatMessage(messages.white) },
              {
                name: 'transparent',
                label: intl.formatMessage(messages.transparent),
              },
            ]}
            onChange={(name, value) => {
              onChangeBlock(block, { ...data, [name]: value });
            }}
          />

          <SizeWidget
            id="size"
            title={intl.formatMessage(messages.size)}
            onChange={(name, value) => {
              onChangeBlock(block, { ...data, [name]: value });
            }}
          />
        </Accordion.Content>
      </Accordion>
    </Segment.Group>
  );
};

Sidebar.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.any,
  setSelected: PropTypes.func,
};

export default injectIntl(Sidebar);
